import { render } from "./MsSplitButton.vue?vue&type=template&id=e3fab038&scoped=true"
import script from "./MsSplitButton.vue?vue&type=script&lang=js"
export * from "./MsSplitButton.vue?vue&type=script&lang=js"

import "./MsSplitButton.vue?vue&type=style&index=0&id=e3fab038&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3fab038"]])

export default __exports__